
<template>
  <div class="layout-col">
    <section class="-wrapper-tile -wrapper-column -h-center-" style="height: 100%; display: flex">
      <div class="-header">
        <p class="-h2 -font-weight-medium">{{ $t('pages_dashboard_notice.header') }}</p>
      </div>
      <div class="-width-100 -folding-table-wrapper" style="flex: 1">
        <table class="-table no-border-top -width-100" style="table-layout: fixed" id="dashboard-notice-table" summary="board list table">
          <colgroup>
            <col style="width: 60px;" />
            <col />
            <col style="width: 160px;" />
          </colgroup>
          <thead>
          <tr>
            <th scope="col">
              <div class="-wrapper-v-center">
                <span>No.</span>
              </div>
            </th>
            <th scope="col">
              <div class="-wrapper-v-center">
                <span>{{ $t('pages_dashboard_notice.title') }}</span>
              </div>
            </th>
            <th scope="col">
              <div class="-wrapper-v-center">
                <span>{{ $t('pages_dashboard_notice.created') }}</span>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr @click="moveInfo(item.id)" :id="'dashboard-notice-click-'+item.id" class="-button-ui" v-for="item in notices" :key="item.id">
            <td >{{ item.no }}</td>
            <td><div style="line-height: 1.25" class="-ellipsis">{{ item.title }}</div></td>
            <td>{{ item.created }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="-wrapper end- -width-100 -px-2 -py-2">
        <button class="-btn borderless- small- -mr-0" @click="moveNotice">
          <span>{{ $t('pages_dashboard_notice.show_all_button') }}</span>
          <span class="material-icons -font-size-12">navigate_next</span>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'board-list-2',
  componentName: 'BoardList2',
  mounted() {
    let payload = { pageNo : 1, size : 5, searchText : null }
    this.selectNoticeList(payload)
  },
  computed: {
    ...mapGetters('dashboard', ['notices']),
    ...mapGetters('user', ['userInfo'])
  },
  methods: {
    ...mapActions('dashboard', ['selectNoticeList']),
    moveNotice() {
      this.$router.push('notice/list')
    },
    moveInfo(id) {
      this.$router.push(`/notice/info?id=`+id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/components/BoardList2.vue